<template>
  <div class="main">
    <div class="title">
    	<div class="t-main">商事律师</div>
    	<div class="t-desc">- COMMERCIAL LAWYER -</div>
    </div>
    <div class="classify">
    	<div class="c-list" @click="changeTag(true)">
    		<img src="/static/img/classify.png" class="c-img">
    		<div class="c-name">领域分类</div>
    		<img src="/static/img/down.png" class="c-img">
    	</div>
    	<div class="c-center"></div>
    	<selectCity>
	    	<div class="c-list" ><!-- @click="changeTag(false)" -->
		    	<img src="/static/img/address.png" class="c-img">
		    	<div class="c-name">{{$store.state.locationCity.length ? $store.state.locationCity[$store.state.locationCity.length - 1] : '定位中...'}}</div>
		    	<img src="/static/img/down.png" class="c-img">
	    	</div>
    	</selectCity>
    </div>
    <div class="classify-list" v-if="showTag">
    	<div class="list-box">
    		<div :class="checkNum === 0 ? 'list-sel' : 'list-not'" @click="selAll">全部</div>
    		<div :class="checkNum == item.id ? 'list-sel' : 'list-not'" v-for="(item,index) in tabList" :key="index" @click="selClassify(item.id)">{{item.name}}</div>
    	</div>
    </div>
    <!-- <div class="classify-list" v-if="!showTag">
    	<div></div>
    </div> -->
    <div class="lawyer-list">
    	<div v-if="!lawyerList.length" class="noList">暂时没有该领域的律师</div>
    	<div v-else v-for="(item , index) in lawyerList" :key="index" class="lists">
	    	<div class="l-list" @mouseenter="hoverChange(index,true)" @click="$router.push({name: 'personalCenter', params: {id: item.id}})">
	    		<img :src="$avatarHash(item.id)" class="l-img">
	    		<img v-if="item.is_seeds" src="/static/img/isSeedUser.png" class="l-isSeedUser">
	    		<img v-if="item.is_vip" src="/static/img/isviplawyer.png" class="l-isvip">
	    		<div class="l-name"><div class="l-name-desc">{{item.real_name || item.name}}</div><img src="/static/img/islawyer.png" class="name-img"></div>
	    		<div class="l-speciality">{{item.tag_name[0]}}</div>
    		</div>
    		<div class="l-lists" v-if="item.isHover"  @mouseleave="hoverChange(index,false)">
    			<div class="hover-list" @click="$router.push({name: 'personalCenter', params: {id: item.id}})">
    				<img :src="$avatarHash(item.id)" class="l-img">
    				<img v-if="item.is_seeds" src="/static/img/isSeedUser.png" class="l-isSeedUser">
		    		<img v-if="item.is_vip" src="/static/img/isviplawyer.png" class="l-isvip">
		    		<div class="l-name"><div class="l-name-desc">{{item.real_name || item.name}}</div><img src="/static/img/islawyer.png" class="name-img"></div>
		    		<div v-if="item.is_seeds" class="l-seedUser">【种子用户】</div>
		    		<div v-else class="l-speciality">{{item.tag_name[0]}}</div>
    			</div>
    			<div class="hover-r">
    				<div v-if="item.is_seeds">
    					<el-popover trigger="hover" placement="bottom"  width="220">
    						<div class="hover-seed-desc">
    							<div>1、授权终身免费使用</div>
    							<div>2、三个月未使用取消授权，</div>
    							<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;特殊情况经平台同意可保留</div>
    						</div>
    						<div class="hover-seeds" slot="reference">
    							<div>种子授权说明</div>
    							<img src="/static/img/explain.png">
    						</div>
    					</el-popover>
    				</div>
    				<div class="hover-tag" :class="item.is_seeds == 1 ? 'hover-tag-seed':''">
	    				<div v-for="(items , i) in item.tag_name" class="hover-tags">{{items}}</div>
    				</div>
    				<div class="hover-desc">
    					<div class="hover-title">律所：</div>
    					<div class="hover-name">{{item.company}}</div>
    				</div>
    				<div class="hover-desc">
    					<span class="hover-title">简介：</span>
    					<span class="hover-name profile">{{item.profile}}</span>
    				</div>
    				<div class="hover-desc">
    					<div class="hover-title">电话：</div>
    					<div class="hover-name">{{filterphone(item.phone)}}<span v-if="!isLogin" style="margin-left:10px;font-size:12px;color:#071336;opacity:0.4;cursor:pointer;" @click="$store.commit('changeLoginModalStatus', {display: true, type: 'login'})">登录后可见</span></div>
    				</div>
    				<div class="hover-btn">
	    				<div class="btn-follow" v-if="item.followed == 0 || !isLogin" @click="follow(item.id,index)">关注</div>
	    				<div class="btn-follow" v-else @click="unfollow(item.id,index)">已关注</div>
	    				<div class="btn-consult" @click="gotoChat(item.id)">咨询</div>
	    			</div>
    			</div>
    		</div>
    	</div>
    </div>
    <div class="btn" @click="$router.push({path: 'lawyer'})">更多</div>
  </div>
</template>

<script>
import selectCity from "@/components/selectCity";
export default {
  name: 'LawyerList',
  data () {
    return {
      tabList:[],
      checkNum : 0,
      lawyerList:[],
      showTag:true  //显示领域或者地址选项
    }
  },
  computed:{
  	positionCity() {
      return this.$store.state.locationCity;
    },
    isLogin() {
        return this.$store.state.loginStatus;
    },
  },
  components: {selectCity},
  mounted(){
  	this.getLawList();
  	this.getTagList();
  },
  methods:{
  	filterphone(str) {
      let r = '未填写手机号';
      if( str ){
        r = this.isLogin ? str : str.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2');
      }
      return r;
    },
  	//获取标签列表
  	getTagList(){
  		let url = 'home/lawyer/getTopCategory';
  		this.$http.get(url).then(res => {
  			if(res.data.retcode == $conf.RETCODE_OK){
  				this.tabList = res.data.data;
  			}
  		})
  	},
  	// 关注
    follow(id,index) {
      if( !this.isLogin ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        return;
      }
      this.$ajax('post', 'user/follow/' + id, data => {
        this.lawyerList[index].followed = 1;
        this.$message.success( '关注成功！' );
      });
    },
    // 取关
    unfollow(id,index) {
      if( !this.isLogin ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        return;
      }
      this.$ajax('post', 'user/unfollow/' + id, data => {
        this.lawyerList[index].followed = 0;
        this.$message.success( '已取消关注！' );
      });
    },
    //打开私信
  	gotoChat(id) {
      if( !this.isLogin ){
        this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        setTimeout(() => {
          this.$message.warning( '请先登录后，再次执行操作！' );
        }, 200);
        return;
      }
      // this.$gotov1('/feed?v2chat=' + this.userInfo.id);
      this.startGetInfo(id)

    },
    startGetInfo(uid) {
      this.$ajax('get', `/userinfo/detail/${uid}`, (data) => {
          this.startChat(data.data);
      });
    },
    startChat(user) {
        if(this.$store.state.mineInfo && this.$store.state.mineInfo.id){
            this.$store.commit("changeCurcontactInfo", { id: user.id, name: user.name});

            if(!this.isshowchatpanel){
                this.$store.commit('setSide', 'chat');
            }
        }else{
            this.$Message.error('未登录，请先登录后再发起私信！');
        }
    },
  	//获取律师列表
  	getLawList(){
  		let text = this.positionCity[0] && this.positionCity[0].indexOf('市') == -1? '': this.positionCity[0] + '-';
        text  = text + this.positionCity.join('-');
  		let url = 'home/lawyer/getHomeLawyerList';
  		let param = {position:text,top_category_id:this.checkNum};
  		this.$http.get(url, {params:param} ).then(res => {
  			if(res.data.retcode == $conf.RETCODE_OK){
  				res.data.data.forEach((val) =>{
  					val.isHover = false;
  					if (val.followed == undefined) {
                        val.followed = 0;
                    }
  				});
  				this.lawyerList = res.data.data;
  			}
  		})
  	},
  	//选择领域或地址
  	changeTag(status){
  		this.showTag = status;
  	},
  	//全选
  	selAll(){
  		this.checkNum = 0;
  		this.getLawList();
  	},
  	//选择标签
  	selClassify(id){
  		this.checkNum = id;
  		this.getLawList();
  	},
  	//鼠标的滑动事件
  	hoverChange(index,status){
  		this.lawyerList[index].isHover = status;
  	}
  },
  watch:{
  	positionCity: {
      deep: true,
      handler(v, ov) {
      	let text = v[0] && v[0].indexOf('市') == -1? '': v[0] + '-';
        text  = text + v.join('-');
        this.getLawList();
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.main
	height:918px;
	background:#FFFFFF;
	margin:0 15%;
	.title
		display:flex;
		flex-direction:column;
		align-items:center;
		padding-top:50px;
		margin-bottom:40px;
		.t-main
			height:59px;
			font-size:42px;
			font-weight:400;
			color:rgba(7,19,54,1);
			line-height:59px;
			margin-bottom:10px;
		.t-desc
			height:22px;
			font-size:16px;
			font-weight:400;
			color:rgba(7,19,54,0.4);
			line-height:22px;
	.classify
		display:flex;
		align-items:center;
		.c-list
			display:flex;
			align-items:center;
			cursor:pointer;
			.c-img
				width:17px;
				height:17px;
				margin-right:5px;
			.c-name
				height:22px;
				font-size:16px;
				font-weight:500;
				color:rgba(7,19,54,0.8);
				line-height:22px;
				margin-right:5px;
		.c-center
			background:#EFEFEF;
			width:1px;
			height:16px;
			margin:0 10px;
	.classify-list
		width:1321px;
		height:59px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 10px 0px rgba(39,81,203,0.09);
		border-radius:5px;
		margin-top:24px;
		.list-box
			height:59px;
			margin-left:50px;
			display:flex;
			align-items:center;
			.list-sel
				height:27px;
				padding:0 10px;
				line-height:27px;
				background:rgba(39,81,203,1);
				border-radius:20px;
				font-size:14px;
				font-weight:400;
				color:rgba(255,255,255,1);
				text-align:center;
				margin-right:50px;
				cursor:pointer;
			.list-not
				height:27px;
				padding:0 10px;
				line-height:27px;
				border-radius:20px;
				font-size:14px;
				font-weight:400;
				color:#676F86;
				text-align:center;
				margin-right:50px;
				cursor:pointer
	.lawyer-list
		margin-top:25px;
		display:flex;
		flex-wrap: wrap;
		width:1321px;
		height:490px;
		.noList
			text-align:center;
			width:1321px;
			margin-top:200px;
			font-size:20px;
		.lists
			position: relative;
			width:165px;
			.l-list
				text-align:center;
				margin:25px 0px;
				position: relative;
				z-index:1;
				.l-img
					width:117px;
					height:117px;
					border-radius:80px;
				.l-isvip
					position: absolute;
					width:27px;
					height:27px;
					right:34px;
					bottom:81px;
				.l-isSeedUser
					position: absolute;
					width:83px;
					height:42px;
					top:-23px;
					right:41px;
				.l-name
					height:25px;
					font-size:18px;
					font-weight:500;
					color:rgba(7,19,54,1);
					line-height:25px;
					margin-top:13px;
					display:flex;
					justify-content:center;
					align-items:center;
					.l-name-desc
						height:25px;
						line-height:25px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow:ellipsis;
					.name-img
						width:16px;
						height:18px;
						margin-left:6px;
				.l-speciality
					margin:0 auto;
					width:83px;
					height:28px;
					line-height:28px;
					background:rgba(248,248,248,1)
					border-radius:15px;
					margin-top:6px;
					font-size:14px;
					font-weight:400;
					color:rgba(7,19,54,1);
			.l-lists
				width:469px;
				height:250px;
				background:rgba(255,255,255,1);
				box-shadow:0px 0px 10px 0px rgba(39,81,203,0.21);
				border-radius:5px;
				position: absolute;
				top:0px;
				z-index:10;
				display:flex;
				.hover-list
					text-align:center;
					margin:25px 20px;
					position: relative;
					cursor:pointer;
					width:117px;
					.l-img
						width:117px;
						height:117px;
						border-radius:80px;
					.l-isvip
						position: absolute;
						width:27px;
						height:27px;
						right:10px;
						bottom:86px;
					.l-isSeedUser
						position: absolute;
						width:83px;
						height:41px;
						top:-23px;
						right:17px;
					.l-name
						height:25px;
						font-size:18px;
						font-weight:500;
						color:rgba(7,19,54,1);
						line-height:25px;
						margin-top:13px;
						display:flex;
						justify-content:center;
						align-items:center;
						.l-name-desc
							height:25px;
							line-height:25px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow:ellipsis;
						.name-img
							width:16px;
							height:18px;
							margin-left:6px;
					.l-seedUser
						margin:0 auto;
						width:90px;
						height:28px;
						line-height:28px;
						margin-top:6px;
						font-size:14px;
						font-weight:400;
					.l-speciality
						margin:0 auto;
						width:90px;
						height:28px;
						line-height:28px;
						background:rgba(248,248,248,1);
						border-radius:15px;
						margin-top:6px;
						font-size:14px;
						font-weight:400;
						color:rgba(7,19,54,1);
				.hover-r
					margin-right:10px;
					.hover-seeds
						margin-top:15px;
						display:flex;
						justify-content:flex-end;
						div
							font-size:12px;
							color:#040B21;
							margin-right:5px;
							cursor:pointer;
						img
							width:14px;
							height:14px;
							cursor:pointer;
					.hover-seed-desc
						font-size:14px;
						height:20px;
						line-height:20px;
						color:#071336;
					.hover-tag-seed
						margin-top:5px !important;
					.hover-tag
						display:flex;
						margin-top:30px;
						.hover-tags
							padding:0px 10px;
							height:28px;
							line-height:28px;
							background:rgba(248,248,248,1);
							border-radius:15px;
							margin-right:10px;
							font-size:14px;
							font-weight:400;
							color:rgba(7,19,54,1);
					.hover-desc
						display:flex;
						margin-top:10px;
						.hover-title
							width:42px;
							height:20px;
							font-size:14px;
							font-weight:400;
							color:rgba(7,19,54,0.4);
							line-height:20px;
						.hover-name
							width:230px;
							height:20px;
							font-size:14px;
							font-weight:400;
							color:rgba(7,19,54,1);
							line-height:20px;
						.profile
							min-height:40px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
							overflow: hidden;
							text-overflow:ellipsis;
					.hover-btn
						display:flex;
						justify-content:space-between;
						font-size:14px;
						font-weight:500;
						margin-top:20px;
						cursor:pointer;
						.btn-follow
							width:78px;
							height:31px;
							line-height:31px;
							text-align:center;
							background:rgba(39,81,203,1);
							color:rgba(255,255,255,1);
							border-radius:16px;
						.btn-consult
							width:78px;
							height:31px;
							line-height:31px;
							text-align:center;
							background:rgba(233,239,255,1);
							color:rgba(39,81,203,1);
							border-radius:16px;
							margin-right:50px;
	.btn
		margin:25px auto;
		width:143px;
		height:42px;
		line-height:42px;
		text-align:center;
		background:rgba(39,81,203,1);
		box-shadow:0px 5px 20px 0px rgba(39,81,203,0.49);
		border-radius:21px;
		font-size:16px;
		font-weight:500;
		color:rgba(255,255,255,1);
		cursor:pointer;
</style>


// WEBPACK FOOTER //
// src/components/common/lawyerList.vue